import { ParkingManagementConfigurationListItem, ParkingManagementConfigurationPayload, ParkingManagementConfigurationResponse, ParkingManagementConfigurationError, ParkingManagementConfigurationItem, AddParkingManagementConfigurationResponse, DeletedParkingManagementConfiguration } from '@core/interface/parking-managment-configuration';
import { createActionGroup, props } from '@ngrx/store';

export const ParkingManagementConfigurationActions = createActionGroup({
  source: 'ParkingManagementConfiguration',
  events: {
    'Load ParkingManagementConfiguration List': props<{ key: ParkingManagementConfigurationListItem; data: ParkingManagementConfigurationPayload }>(),
    'Load ParkingManagementConfiguration List Success': props<{
      response: ParkingManagementConfigurationResponse;
      key: ParkingManagementConfigurationListItem;
    }>(),
    'Load ParkingManagementConfiguration List Failure': props<{ error: ParkingManagementConfigurationError; key: ParkingManagementConfigurationListItem }>(),
    'Add Edit ParkingManagementConfiguration': props<{ data: ParkingManagementConfigurationItem; key: ParkingManagementConfigurationListItem }>(),
    'Update ParkingManagementConfiguration Success': props<{
      response: AddParkingManagementConfigurationResponse;
      key: ParkingManagementConfigurationListItem;
    }>(),
    'Update ParkingManagementConfiguration Failure': props<{ error: ParkingManagementConfigurationError; key: ParkingManagementConfigurationListItem }>(),
    'Delete ParkingManagementConfiguration': props<{ id: number; key: ParkingManagementConfigurationListItem }>(),
    'Delete ParkingManagementConfiguration Success': props<{
      response: DeletedParkingManagementConfiguration;
      key: ParkingManagementConfigurationListItem;
    }>(),
    'Delete ParkingManagementConfiguration Failure': props<{ error: ParkingManagementConfigurationError; key: ParkingManagementConfigurationListItem }>(),
    'Reset ParkingManagementConfiguration Status': props<{ key: ParkingManagementConfigurationListItem }>(),
    'Reset ParkingManagementConfiguration List': props<{ key: ParkingManagementConfigurationListItem }>()
  },
});
